import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Carousel } from "react-responsive-carousel";
import parse from "html-react-parser";
import axios from "axios";
import _ from "lodash";
import { useMediaQuery } from "react-responsive";
import { appLink } from "constants/appLinks";
import { PrimaryButton } from "components/buttons";

function Deals({ dealsData }) {
  const [currentSlide, setSlide] = useState(0);
  const isMobileSize = useMediaQuery({ maxWidth: 767 });
  const isSmallScreen = useMediaQuery({ maxWidth: 360 });

  const redirectToStore = (links) => {
    const ua = navigator.userAgent.toLowerCase();

    if (/huawei|honor/.test(ua)) {
      window.location.href = links.huawei;
    } else if (/android/.test(ua)) {
      window.location.href = links.android;
    } else if (/iphone|ipad|ipod/.test(ua)) {
      window.location.href = links.ios;
    } else {
      // fallback or show all options
      alert("Unsupported device");
    }
  };

  const slides =
    !_.isEmpty(dealsData) &&
    dealsData.map((content) => (
      <img
        src={content.image || content.imageLink}
        style={{
          maxHeight: "500px",
          objectFit: "contain",
        }}
        alt="Deal Image"
        className="deal-image"
      />
    ));

  const content =
    !_.isEmpty(dealsData) &&
    dealsData.map((content, index) => (
      <div className="text-center text-md-start">
        <div>
          <h1>
            {typeof content.title === "string"
              ? parse(content.title)
              : content.title}
          </h1>
        </div>
        <div className="my-4 short-desc">
          <span>
            {typeof content.description === "string"
              ? parse(content.description)
              : content.description}
          </span>
        </div>
        {isMobileSize && content.button && (
          <PrimaryButton
            text={content.button}
            onClick={() => redirectToStore(appLink)}
            style={{ minWidth: "260px", fontSize: "14px", fontWeight: "500" }}
          />
        )}
      </div>
    ));

  return (
    <div className="hero-container">
      <Container fluid className="container">
        <Row className="flex-column-reverse flex-md-row text-center text-md-start">
          <Col md="5" data-aos="fade-right" className="align-self-center">
            <Carousel
              autoPlay
              infiniteLoop
              showArrows={false}
              showStatus={false}
              showIndicators={false}
              swipeable
              showThumbs={false}
              stopOnHover={false}
              selectedItem={currentSlide}
              onChange={(index) => setSlide(index)}
            >
              {slides}
            </Carousel>
          </Col>
          <Col md="7" className="align-self-center px-md-5 mb-5 mb-md-0">
            <div data-aos="fade-left">
              {
                dealsData.length > 1 && (
                  <div className="d-inline-flex justify-content-between pb-3">
                    {dealsData.map((_, index) => (
                      <div
                        key={index}
                        onClick={() => setSlide(index)}
                        className={` rounded-circle p-1 mx-1 cursor-pointer ${
                          index === currentSlide
                            ? `primary-background`
                            : isMobileSize
                            ? `grey-background`
                            : `bg-white`
                        }`}
                      />
                    ))}
                  </div>
                )
              }
              <Carousel
                autoPlay
                infiniteLoop
                showArrows={false}
                showStatus={false}
                showIndicators={false}
                showThumbs={false}
                swipeable
                stopOnHover={false}
                selectedItem={currentSlide}
                onChange={(index) => setSlide(index)}
              >
                {content}
              </Carousel>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Deals;
